import type { EasingType } from '@visactor/vrender-core';
import type { ArcSegment, Segment } from '../../segment';
import type { Tag } from '../../tag';
import { getSegmentLineGraphics, graphicFadeIn } from './common';
import { array } from '@visactor/vutils';
import { commitUpdateAnimationTarget } from '../../animation/static-truth';

export function commonLineClipIn(
  line: Segment | ArcSegment,
  label: Tag | Tag[],
  duration: number,
  delay: number,
  easing: EasingType
) {
  const startSymbolDuration = 0.1 * duration;
  const lineDuration = 0.7 * duration;
  const endSymbolDuration = 0.1 * duration;
  const labelDuration = 0.1 * duration;

  // start symbol
  graphicFadeIn(line.startSymbol, delay, startSymbolDuration, easing);

  // line
  const lines = getSegmentLineGraphics(line);
  lines.forEach(line => commitUpdateAnimationTarget(line, { clipRange: 1 }, { clipRange: 0 }));
  lines.forEach((l, index) => {
    const stepDuration = lineDuration / lines.length;
    l.animate()
      .wait(delay + startSymbolDuration + index * stepDuration)
      .to({ clipRange: 1 }, stepDuration, easing);
  });

  // end symbol
  graphicFadeIn(line.endSymbol, delay + startSymbolDuration + lineDuration, endSymbolDuration, easing);

  // label
  array(label).forEach(labelNode => {
    const delayTime = delay + startSymbolDuration + lineDuration + endSymbolDuration;
    // text
    graphicFadeIn(labelNode.getTextShape(), delayTime, labelDuration, easing);

    // text background
    graphicFadeIn(labelNode.getBgRect(), delayTime, labelDuration, easing);
  });
}
